export default "__VITE_ASSET__e83099cb__"